import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser"

const TextItem = (props) => {

    const { title, textArray } = props
    const isMobile = useMediaQuery({ maxWidth: 1280 })

    if (isMobile)
        return (
            <section className="flex w100 white-bkg">
                <section className="main-middle-section-mobile">

                    <section className="main-middle-subsection-mobile">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t, index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                </section>
            </section>
        )
    else
        return (
            <section className="flex w100 white-bkg">
                <section className={"flex col acenter jcenter main-middle-section-2 "}>

                    <section className="main-middle-subsection-2 pad-10 w100">
                        <h2 className="middle-section-title">{title}</h2>
                        {
                            (textArray?.map((t, index) => {
                                return (<article key={index}>{parse(t)}</article>)
                            }))
                        }
                    </section>

                </section>
            </section>
        )

}

export default TextItem